import { AlertCircle } from 'lucide-react';
import * as React from 'react';

import { Badge } from '@/components/ui/badge';
import type { TaskActivity } from '@/services/api/generated/taskActivityService';

import { EventBody, EventContainer, EventHeader } from './EventPrimitives';

interface FallbackEventProps {
  activityItem: TaskActivity;
}

export const FallbackEvent: React.FC<FallbackEventProps> = ({
  activityItem,
}) => {
  const { event } = activityItem;
  const { event_code, occurred_at, user, agent } = event;

  // Format event code into a readable title
  const eventTitle = formatEventCode(event_code);

  return (
    <EventContainer>
      <EventHeader
        icon={<AlertCircle size={20} />}
        title={eventTitle}
        timestamp={occurred_at}
        actor={user}
        agent={agent}
      />

      <EventBody>
        <div className="flex items-center gap-2 text-xs">
          <Badge variant="outline" className="text-[11px]">
            {event_code}
          </Badge>
          <span className="text-slate-500 text-[11px]">
            This event type is not yet fully implemented
          </span>
        </div>
      </EventBody>
    </EventContainer>
  );
};

// Helper function to format event code into readable title
function formatEventCode(eventCode: string): string {
  // Convert snake_case to Title Case
  return eventCode
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
